import React, { useEffect, useState } from "react";
import { Loader } from "../loader";
import api from "../../../api";
import moment from "moment";

export const WaqarStats = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const getUsers = async () => {
    try {
      setLoader(true);
      const response = await api.getWaqarStats();
      // console.log(response);

      setData(response);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        <div className="row analytics-row">
          <AnalyticsBox
            icon={<i className="fa-solid fa-user"></i>}
            title="Signup Today"
            amount={data?.signupsToday}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-users"></i>}
            title="Total Paid Members"
            amount={data?.totalPaidMembers}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-plus"></i>}
            title="Paid in 24h"
            amount={data?.paidMembersIn24h}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-minus"></i>}
            title="Un-Subscribed in 24h"
            amount={data?.unsubscribedIn24h}
          />

          <AnalyticsBox
            icon={<i className="fa-solid fa-user"></i>}
            title="Signup in 30 Day"
            amount={data?.signupsIn30Days}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-plus"></i>}
            title="Paid in 30 Day"
            amount={data?.paidMembersIn30Days}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-minus"></i>}
            title="Un-Subscribed in 30 Day"
            amount={data?.unsubscribedIn30Days}
          />

          <AnalyticsBox
            icon={<i className="fa-solid fa-user"></i>}
            title="Signup current Month"
            amount={data?.signupsThisMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-paste"></i>}
            title={`Paid in ${data?.previousMonthName}`}
            amount={data?.paidMembersPreviousMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-minus"></i>}
            title={`Un-Subscribed in ${data?.previousMonthName}`}
            amount={data?.unsubscribedPreviousMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-plus"></i>}
            title={`Paid in ${data?.currentMonthName}`}
            amount={data?.paidMembersThisMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-minus"></i>}
            title={`Un-Subscribed in ${data?.currentMonthName}`}
            amount={data?.unsubscribedThisMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-arrows-up-down"></i>}
            title={`Paid By Previous Month`}
            amount={data?.paidChangePercent}
            side={
              data?.paidChangePercent > 0
                ? "up"
                : data?.paidChangePercent == 0
                ? "neutral"
                : "down"
            }
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-arrows-up-down"></i>}
            title={`Un-sub By Previous Month`}
            amount={data?.unsubChangePercent}
            side={
              data?.unsubChangePercent > 0
                ? "up"
                : data?.unsubChangePercent == 0
                ? "neutral"
                : "down"
            }
          />
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
};

function AnalyticsBox(props) {
  return (
    <div className="col-xxl-3 col-xl-4 col-md-6 mb-4">
      <div className="card h-100 py-2 border-transparent br-10 ">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col">
              {/* <img className="analytic-box-img" src={props.icon} alt="" /> */}
              <div className="analytic-box-img">{props.icon}</div>
            </div>
            <div className="col-auto mr-2">
              <div className="text-xs font-weight-bold  mb-1">
                <span className="analytics-box-title">{props.title}</span>
              </div>
              <div className="h3 mb-0 font-weight-bold text-gray-800">
                {props?.side == "up" ? (
                  <span className=" color-green">
                    <i className="fa-solid fa-circle-up me-2"></i>
                    {props.amount}%
                  </span>
                ) : props?.side == "down" ? (
                  <span className="me-2 color-red">
                    <i className="fa-solid fa-circle-down me-2"></i>
                    {props.amount}%
                  </span>
                ) : props?.side == "neutral" ? (
                  <span className="me-2 ">{props.amount}%</span>
                ) : (
                  <span className="me-2">{props.amount}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
